import { BasicWriter } from "@/components/Writer/BasicWriter";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { DependenciesList } from "@/components/content-dependency/DependenciesList";
import { useExpertEditData } from "@/data/use-expert-edit-data";
import { useExpertData } from "@/data/use-experts-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { useEffect, useRef } from "react";

export function ExpertContextPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { expert } = useExpertEditData({ groupUuid, kitUuid });

  if (!expert) {
    return null;
  }

  return (
    <Page document>
      <PageHeader document>
        <PageHeader.Title>Context</PageHeader.Title>
      </PageHeader>
      <ExpertBody key={expert.uuid} exportUuid={expert.uuid} />
    </Page>
  );
}

function ExpertBody({ exportUuid }: { exportUuid: string }) {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const contextRef = useRef<string>("");
  const tovRef = useRef<string>("");
  const hasInitialized = useRef(false);
  const { updateExpert, expert } = useExpertData(
    groupUuid,
    kitUuid,
    exportUuid,
  );

  useEffect(() => {
    if (expert && !hasInitialized.current) {
      contextRef.current = expert.context;
      tovRef.current = expert.toneOfVoice;
      hasInitialized.current = true;
    }
  }, [expert]);

  // Handle context updates from BasicWriter (debounced internally)
  const handleContextUpdate = (html: string) => {
    if (expert) {
      updateExpert({
        context: html,
      });
    }
  };

  if (!expert) {
    return null;
  }

  return (
    <PageBody document>
      <DependenciesList dependencies={expert.dependencies} />
      <BasicWriter
        key={`context-${expert.uuid}`}
        content={expert.context}
        onUpdate={handleContextUpdate}
        onChange={(html) => {
          contextRef.current = html;
        }}
        placeholder="Expert context..."
        hasToolbar={false}
        includeSkillMentions
      />
    </PageBody>
  );
}
